export enum RoleName {
  admin_client = 'admin_client',
  bizzdev = 'bizzdev',
  super_admin = 'super_admin',
  driver = 'driver',
  client = 'client',
  dispatcher = 'dispatcher',
  admin = 'admin',
  admin_subcontractor = 'admin_subcontractor'
}
